import React from 'react';
import { Link, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';


const FooterBar = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(3),
  color: theme.palette.text.secondary,
/*   position: 'absolute',
  left:0,
  bottom: 0, */
  display:'block',
  width:'90%',
  boxShadow:'none'
}));

export default function Footer() {
  return (
    <FooterBar>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://www.berkeleyfoundation.org.uk/">
          Berkeley Foundation
        </Link>{' '}
        {new Date().getFullYear()}
      </Typography></FooterBar>
  );
}
